import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { BaseComponent } from 'src/app/core/components/base.component';
import DateTimeHelper from 'src/app/core/helpers/date-time.helper';
import * as moment from 'moment';
import { Moment } from 'moment';
import DateTimeFormats from 'src/app/core/constants/date-time-formats';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM.YYYY',
  },
  display: {
    dateInput: 'MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-year-month-calendar',
  templateUrl: './year-month-calendar.component.html',
  styleUrls: ['./year-month-calendar.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }
  ],
})
export class YearMonthCalendarComponent extends BaseComponent implements OnInit {
  @Input() dateControl: FormControl | undefined;
  @Input() label!: string;
  @Input() hintLabel!: string;
  @Input() initialize: boolean | undefined;
  @Input() end!: boolean;
  @Input() datepickerFilter: any;
  @Output() dateSelected = new EventEmitter();
  thisMonth = new Date();
  dateTimeFormats = DateTimeFormats;

  constructor() {
    super();
  }

  ngOnInit(): void {
    if (this.initialize) {
      if (this.dateControl?.value) {
        this.dateControl.patchValue(moment(this.dateControl.value));
      }
      else {
        this.dateControl?.patchValue(moment());
      }
    }
  }

  chosenYearHandler(normalizedYear: Moment) {
    const date = this.setStartOrEndOfMonthDate(normalizedYear);
    this.dateControl?.setValue(date);
    this.changed();
  }

  chosenMonthHandler(normalizedMonth: Moment, datepicker: MatDatepicker<Moment>) {
    const date = this.setStartOrEndOfMonthDate(normalizedMonth);
    this.dateControl?.setValue(date);
    this.changed();
    datepicker.close();
  }

  private setStartOrEndOfMonthDate(value: Moment): Moment {
    if (this.end) {
      return DateTimeHelper.getEndOfMonthDate(value);
    }
    else {
      return DateTimeHelper.getStartOfMonthDate(value);
    }
  }

  onDateChange() {
    this.changed();
  }

  changed(): void {
    this.dateControl?.markAsTouched();
    this.dateControl?.markAsDirty();
    this.dateSelected.emit();
  }

  get hasDateRangeError(): boolean  {
    return this.dateControl!.hasError('max') && this.dateControl!.touched;
  }
}
